module.exports = __webpack_public_path__ + "img/courseModalRules.0131b1e5.jpg";